export class Clientnummer {
  constructor(public nummer: string,
              public zoekMethode: ClientZoekMethode) {
  }
}

export enum ClientZoekMethode {
  NUMMER = 'NUMMER',
  QR_CODE = 'QR_CODE',
}
